import { createFileRoute } from "@tanstack/react-router";

/**
 * Xưởng ghép của một thư mục. `?from=retouch` = mở từ Bàn làm việc hậu kỳ (CEO
 * chốt 1a, 28/10/2026): nút quay lại về đúng bàn của đơn thay vì kho ảnh.
 */
export type ComposeSearch = { from?: "retouch" | undefined };

export const Route = createFileRoute("/_app/gallery/orders/$orderId/compose/$albumId")({
  validateSearch: (search: Record<string, unknown>): ComposeSearch => ({
    from: search.from === "retouch" ? "retouch" : undefined,
  }),
});
